'use strict';

angular.module('app').directive('dateOfBirth', function($timeout, gettextCatalog) {
  return {
    restrict: 'E',
    require: "ngModel",
    scope: {
        startDate: '=',
        minAge: '=',
        maxAge: '='
    },
    template: '<div class="dob-selector"><select id="dobday" ng-model="date.dobDay"></select>'+
        '<select id="dobmonth" ng-model="date.dobMonth"></select>'+
        '<select id="dobyear" ng-model="date.dobYear"></select></div>',
    link: function(scope, _, _, ngModelCtrl) {
        $timeout(function() {
            jQuery.dobPicker({
                daySelector: '#dobday', /* Required */
                monthSelector: '#dobmonth', /* Required */
                yearSelector: '#dobyear', /* Required */
                dayDefault: gettextCatalog.getString('Day'), /* Optional */
                monthDefault: gettextCatalog.getString('Month'), /* Optional */
                yearDefault: gettextCatalog.getString('Year'), /* Optional */
                minimumAge: Number.isInteger(scope.minAge) ? scope.minAge : 12, /* Optional */
                maximumAge: Number.isInteger(scope.maxAge) ? scope.maxAge : 120 
            });

            if (ngModelCtrl.$modelValue) {
                var dob = ngModelCtrl.$modelValue.split('-')

                scope.date = {
                    dobYear: dob[0],
                    dobMonth: dob[1],
                    dobDay: dob[2]
                }
            }

            scope.$watch(function() {
                return ngModelCtrl.$modelValue 
            }, function(newVal, oldVal) {
                if (newVal) {
                    var dob = ngModelCtrl.$modelValue.split('-')

                    $('#dobday').val(dob[2])
                    $('#dobmonth').val(dob[1])
                    $('#dobyear').val(dob[0])
                }
            })
    
            scope.$watchCollection('date',function(newVal) {
                if (newVal && newVal.dobDay && newVal.dobMonth && newVal.dobYear) {
                    $timeout(function() {
                        ngModelCtrl.$setViewValue(newVal.dobYear + '-' + newVal.dobMonth + '-' + newVal.dobDay)
                    }) 
                } else {
                    $timeout(function() {
                        ngModelCtrl.$setViewValue(undefined)
                    })
                }
            })
        })
    }
  }
});